import { combineReducers, createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { thunk } from "redux-thunk";
import { currentUserReducer } from "./currentUserReducer";
import { clinicsReducer } from "./clinicsReducer";
import { recordsTableReducer } from "./recordsTableReducer";
import { scheduleReducer } from "./scheduleReducer";
import { personalScheduleReducer } from "./personalScheduleReducer";
import { notificationsReducer } from "./notificationsReducer";
import { servicesReducer } from "./servicesReducer";
import { settingsReducer } from "./settingsReducer";
import { specialistsReducer } from "./specialistsReducer";

const rootReducer = combineReducers({
    currentUser: currentUserReducer,
    clinics: clinicsReducer,
    recordsTable: recordsTableReducer,
    schedule: scheduleReducer,
    personal: personalScheduleReducer,
    notifications: notificationsReducer,
    services: servicesReducer,
    settings: settingsReducer,
    specialists: specialistsReducer,
})

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))
